import { EMPTY_FORM_TOKEN_CHAIN } from '../constants';
import { FormTokenChainState, FormTokenNode, TokenId } from '../types/context';

// Keeps only the chain the active token belongs to (root + all its descendants)
export const pruneFormTokensToActiveChain = (
  formTokens: FormTokenChainState,
  activeTokenId: TokenId | null
): FormTokenChainState => {
  if (!activeTokenId || !formTokens.nodes[activeTokenId]) {
    return EMPTY_FORM_TOKEN_CHAIN;
  }

  let rootNode = formTokens.nodes[activeTokenId];
  const visited = new Set<TokenId>([rootNode.id]);
  while (rootNode.parentTokenId) {
    const parentNode = formTokens.nodes[rootNode.parentTokenId];
    if (!parentNode || visited.has(parentNode.id)) {
      break;
    }
    visited.add(parentNode.id);
    rootNode = parentNode;
  }

  const chainNodes: Record<TokenId, FormTokenNode> = {};
  let currentNode: FormTokenNode | undefined = rootNode;
  while (currentNode && !chainNodes[currentNode.id]) {
    chainNodes[currentNode.id] = currentNode;
    currentNode = currentNode.childTokenId
      ? formTokens.nodes[currentNode.childTokenId]
      : undefined;
  }

  return { nodes: chainNodes, roots: [rootNode.id] };
};
